import { gql } from '@apollo/client';

export const GET_ALL_EMAIL_TEMPLATES = gql`
  query GetAllEmailTemplates($employeeId: String!) {
    getAllEmailTemplates(employeeId: $employeeId) {
      status
      message
      response {
        id
        name
        subject
        body
        category
        employeeId
        createdAt
        updatedAt
      }
    }
  }
`;

export const ADD_EMAIL_TEMPLATE = gql`
  mutation AddEmailTemplate(
    $name: String!
    $subject: String!
    $body: String!
    $category: String
    $employeeId: String!
  ) {
    addEmailTemplate(name: $name, subject: $subject, body: $body, category: $category, employeeId: $employeeId) {
      status
      message
      response {
        id
        name
        subject
        body
        category
        employeeId
      }
    }
  }
`;

export const UPDATE_EMAIL_TEMPLATE = gql`
  mutation UpdateEmailTemplate(
    $id: ID!
    $name: String!
    $subject: String!
    $body: String!
    $category: String
  ) {
    updateEmailTemplate(id: $id, name: $name, subject: $subject, body: $body, category: $category) {
      status
      message
      response {
        id
        name
        subject
        body
        category
        employeeId
      }
    }
  }
`;

export const DELETE_EMAIL_TEMPLATE = gql`
  mutation DeleteEmailTemplate($id: ID!, $employeeId: String!) {
    deleteEmailTemplate(id: $id, employeeId: $employeeId) {
      status
      message
      response {
        id
      }
    }
  }
`;
